/*
 * Seconds to Days, Hours, Minutes and Seconds
 * sectionsToDHMS(5238322.2)
 * @return string
 */
function secondsToDHMS(seconds) {
    seconds = Number(seconds)
    const d = Math.floor(seconds / (3600 * 24))
    const h = Math.floor((seconds % (3600 * 24)) / 3600)
    const m = Math.floor((seconds % 3600) / 60)
    const s = Math.floor(seconds % 60)

    const dDisplay = d > 0 ? d + (d === 1 ? "&nbsp;day, " : "&nbsp;days, ") : " 0&nbsp;days, "
    const hDisplay = h > 0 ? h + (h === 1 ? "&nbsp;hour, " : "&nbsp;hours, ") : " 0&nbsp;hours, "
    const mDisplay = m > 0 ? m + (m === 1 ? "&nbsp;minute, " : "&nbsp;minutes, ") : " 0&nbsp;minutes, "
    const sDisplay = s > 0 ? s + (s === 1 ? "&nbsp;second" : "&nbsp;seconds") : " 0&nbsp;seconds"

    return dDisplay + hDisplay + mDisplay + sDisplay
}

$(document).ready(() => {
    const $weeklyAdsPageTurner = $('.weekly-ads__pageturner')
        .kendoWindow({
            modal: {
                preventScroll: true
            },
            position: {
                top: 0,
                left: 0,
            },
            content: {
                url: 'https://www.paperturn-view.com/american-furniture-warehouse/co-07-07?pid=ODg8818860&v=1.1&bgcolor=transparent&embed=script&shadow=1&flipSound=&hardCover=',
                iframe: true
            },
            title: $('.weekly-ads__pageturner').data('modal-title') || 'Weekly Ads',
            visible: false,
            actions: ['Close'],
            animation: false,
            appendTo: '.weekly-ads',
        }).data('kendoWindow')

    $('.weekly-ads__pageturner__open').on('click touch', () => {
        $weeklyAdsPageTurner.open().maximize()
    })

    const $weeklyAdsTimeLeft = $('.weekly-ads__timeleft')

    const dateExp = new Date($weeklyAdsTimeLeft.data('time-left'))
    setInterval(() => {
        const dateNow = new Date()
        const timeLeft = (dateExp.getTime()/1000) - (dateNow.getTime()/1000)
        $('span', $weeklyAdsTimeLeft).html(secondsToDHMS(timeLeft))
    }, 1000)
})